/**
 * 钢筋笼管理
 */
 import axios from '../request';
 
 export default{
    /**
  * 钢筋笼生产
  */
    // 查询钢筋笼生产信息列表
    searchReinforcement: params =>
        axios.post('/materials/steelProduce/steelProduceList', params),
    // 钢筋笼质检追溯
    detailsReinforcement: params =>
        axios.get('/materials/steelProduce/steelProduceInfo', {params}),
    //导出数据
    exportDatas:params=>
        axios({
            method: 'post',
            url: '/materials/steelProduce/produceExport',
            responseType: 'blob',
            data: params
        }),

    /**
     * 钢筋笼库存
     */
    //查询钢筋笼库存列表
    searchInventory: params =>
        axios({
            method: 'post',
            headers: {
                pageNum: params.pageNum,
                pageSize: params.pageSize,
            },
            url:'/m/steelStock/findList',
            data: params
        }),
    //查询存在问题
    searchQuessions: params =>
        axios.post('/materials/steelProduce/steelProduceCheck', params),
    //提交存在问题
    submitQuessions: params =>
        axios.post('/materials/steelProduce/steelProduceFeedback', params),

    /**
     * 成环统计
     */
    //查询配筋块号数据列表(数据)
    searchRing: params =>
        axios.post('/materials/steelProduce/produceLooping', params),
    //查询项目尺寸(数据) 
    searchProjectSize: params =>
        axios.post('/engineering/project/projectSizeList', params),
    //查询项目配筋和块号(数据) 
    searchProjectBears: params =>
        axios.get('/engineering/project/projectProList', {params}),

 }